export default __webpack_public_path__ + "static/media/5.17d09a05.png";